module.exports = __webpack_public_path__ + "static/media/rebeccaHeadshot.8bf89c47.jpg";